<div class="doc-wrapper start-fr-dock" [hidden]="hideDock">
  <h2>Start your Medical Fundraiser right away</h2>
  <form  class="start-fr-form" [formGroup]="basicForm" (ngSubmit)="basic()" autocomplete="off">
    <div class="scrollable-div">
    <app-input
      class="amount-field"
      inputType="number"
      [control]="amount_requested"
      [group]="basicForm"
      [placeHolder]="info.amount.placeholder"
      preIcon="icon-rupee"
      [info]="info.amount.popover"
      [errorMessage]="info.amount.error"
    >
    </app-input>
    <app-input
      class="amount-field"
      inputType="text"
      [control]="name"
      [group]="basicForm"
      [placeHolder]="info.name.placeholder"
      [errorMessage]="info.beneficiaryname.error"
      [hidden]="isLoggedIn"
    >
    </app-input>
    <mat-form-field class="input-width custom-input">
      <mat-label>The Patient is my...</mat-label>
      <mat-select [formControl]="relation">
        <mat-optgroup *ngFor="let group of relationship" [label]="group.name">
          <mat-option *ngFor="let relation of group.relations" [value]="relation.value">
            {{ relation.label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-error *ngIf="relation.hasError('required') && relation.touched">Field required</mat-error>
    </mat-form-field>
      <app-intl-input *ngIf="amount_requested.touched"
        class="intl-input-container custom-input input-width"
        [group]="basicForm"
        [control]="beneficiaryPhone"
        [hideSuffixIcon]="true"
        [hidden]="isLoggedIn && !userData?.beneficiaryPhone">
      </app-intl-input>
    </div>
    <button mat-icon-button type="submit">
      <i class="material-icons" *ngIf="!isLoading">arrow_forward</i>
      <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    </button>
  </form>

</div>
